import { css } from "@emotion/css";
import { Box, Grid, Typography, useMediaQuery, useTheme } from "@mui/material";
import React, { useContext, useEffect, useState } from "react";
import { toast } from "sonner";
import AtlasianLogo from "../../assets/images/ralvie/atlasian_logo.svg";
import { ReactComponent as BiotimeLogo } from "../../assets/images/ralvie/biocloud_logo.svg";
import GitlabLogo from "../../assets/images/ralvie/gitlab_logo.svg";
import { ReactComponent as GmailLogo } from "../../assets/images/ralvie/gmail_logo.svg";
import { ReactComponent as GoogleCalendarLogo } from "../../assets/images/ralvie/google_calendar_logo.svg";
import Banner from "../../assets/images/ralvie/integration_banner.svg.svg";
import { ReactComponent as MsOutlookLogo } from "../../assets/images/ralvie/microsoft_outlook_logo.svg";
import MsTeamsLogo from "../../assets/images/ralvie/microsoft_teams-logo.svg";
import { ReactComponent as MsOffice365Logo } from "../../assets/images/ralvie/office_365_logo.svg";
import WorkdayLogo from "../../assets/images/ralvie/workday_logo_2.svg";
import ZlinkLogo from "../../assets/images/ralvie/zlink_logo.svg";
import { ReactComponent as RefreshIcon } from "../../assets/images/refresh_icon.svg";
import { ReactComponent as RefreshIconDark } from "../../assets/images/refresh_icon_dark.svg";
import CustomDialogBox from "../../components/CustomDialogBox";
import CustomSwitch from "../../components/CustomSwitch";
import ContentLayout from "../../components/layout-components/ContentLayout";
import {
  deleteIntegration,
  getIntegrations,
  initDataSync,
  listUserIntegrations,
} from "../../services/IntegrationService";
import ".//integration.scss";
import BiotimeLogin from "./BiotimeLogin";
import AppContext from "../../config/AppContext";
import { useTranslation } from "react-i18next";
import CommonUtil from "../../util/CommonUtils";
import { sidebarContext } from "../../util/context";
import UpgradePopup from "../../components/subscription-component/UpgradePopup";
import { useNavigate } from "react-router-dom";
import RestrictPermissionPopup from "../../components/subscription-component/RestrictPermissionPopup";
export default function Integration() {
  const { mode } = useContext(AppContext);
  const [openBiotimeForm, setOpenBiotimeForm] = useState(false);
  const [biotimeToggle, setBiotimeToggle] = useState(false);
  const [jiraToggle, setJiraToggle] = useState(false);
  const theme = useTheme();
  const isXlScreen = useMediaQuery(theme.breakpoints.up("xl"));
  const [apps, setApps] = useState([]);
  const [myIntegrations, setMyIntegrations] = useState([]);
  const [biotimeUser, setBioTimeUser] = useState(false);
  const [openConfirmPrompt, setOpenConfrimPrompt] = useState(false);
  const [appIdToDelete, setAppIdtoDelete] = useState(undefined);
  const [reload, setReload] = useState(false);
  const { t, i18n } = useTranslation();
  const { subscriptionDetails } = useContext(sidebarContext);
  const [upgradePopupOpen, setUpgradePopupOpen] = useState(false);
  const [restrictPopupOpen, setRestrictPopupOpen] = useState(false);
  const navigate = useNavigate();

  const data = [
    {
      logo: <BiotimeLogo />,
      name: t("RAL0485"),
      description: t("RAL0486"),
      link: "biotimecloud.info",
      active: false,
      enabled: false,
      authoraizationUrl: "",
    },
    {
      logo: <img src={AtlasianLogo} alt={"AtlasianLogo"} />,
      name: t("RAL0487"),
      description: t("RAL0488"),
      link: "jira.atlassian.com",
      active: false,
      enabled: false,
      authoraizationUrl:
        "https://auth.atlassian.com/authorize?audience=api.atlassian.com&client_id=6tIgO6mNbZ4LUeeKuVNuiiy94YlaSUax&scope=offline_access%20read%3Aissue-event%3Ajira%20read%3Auser%3Ajira%20read%3Aissue-details%3Ajira%20read%3Aaudit-log%3Ajira%20read%3Aavatar%3Ajira%20read%3Afield-configuration%3Ajira%20read%3Aissue-meta%3Ajira%20read%3Aapplication-role%3Ajira%20read%3Agroup%3Ajira%20read%3Aissue-type%3Ajira%20read%3Aproject%3Ajira%20read%3Aproject.property%3Ajira%20read%3Aissue-type-hierarchy%3Ajira%20read%3Aproject-category%3Ajira%20read%3Aproject-version%3Ajira%20read%3Aproject.component%3Ajira&redirect_uri=http%3A%2F%2Flocalhost%3A3000%2Fintegrations%2Fjira%2Fcallback&state=${YOUR_USER_BOUND_VALUE}&response_type=code&prompt=consent",
    },
    {
      logo: <img src={GitlabLogo} alt={"GitlabLogo"} height={56} width={56} />,
      name: t("RAL0489"),
      description: t("RAL0490"),
      link: "gitlab.com",
      active: false,
      enabled: false,
      authoraizationUrl:
        "http://gitlab.zkteco.com/oauth/authorize?client_id=012cf7b341346be49ed47402518c987c781e0c5f83ce3450e7e49d14c656b0ca&redirect_uri=http://localhost:3000/integrations/gitlab/callback&response_type=code&state=STATE&scope=api",
    },
    {
      logo: <GmailLogo />,
      name: t("RAL0491"),
      description: t("RAL0492"),
      link: "gmail.com",
      active: false,
      enabled: false,
      authoraizationUrl:
        "https://accounts.google.com/o/oauth2/v2/auth?scope=https%3A%2F%2Fwww.googleapis.com%2Fauth%2Fuserinfo.profile&access_type=offline&include_granted_scopes=true&response_type=code&state=state_parameter_passthrough_value&redirect_uri=http://localhost:3000/integrations/google/callback&client_id=644972714343-cbf3ol4cfv8tv47vt2r3ntd03ahtkuvi.apps.googleusercontent.com",
    },
    {
      logo: <GoogleCalendarLogo />,
      name: t("RAL0493"),
      description: t("RAL0494"),
      link: "calendar.google.com",
      active: false,
      enabled: false,
      authoraizationUrl:
        "https://accounts.google.com/o/oauth2/v2/auth?scope=https%3A%2F%2Fwww.googleapis.com%2Fauth%2Fuserinfo.profile%20https%3A%2F%2Fwww.googleapis.com%2Fauth%2Fcalendar.readonly&access_type=offline&include_granted_scopes=true&response_type=code&state=calendar&redirect_uri=http://localhost:3000/integrations/google/callback&client_id=644972714343-cbf3ol4cfv8tv47vt2r3ntd03ahtkuvi.apps.googleusercontent.com",
    },
    {
      logo: <MsOutlookLogo />,
      name: t("RAL0495"),
      description: t("RAL0496"),
      link: "outlook.office.com",
    },
    {
      logo: <img src={MsTeamsLogo} alt={"MsTeamsLogo"} />,
      name: t("RAL0497"),
      description: t("RAL0498"),
      link: "microsoftteams.com",
    },
    {
      logo: <MsOffice365Logo />,
      name: t("RAL0499"),
      description: t("RAL0500"),
      link: "office365.com",
    },
    {
      logo: (
        <img src={WorkdayLogo} alt={"WorkdayLogo"} height={56} width={56} />
      ),
      name: t("RAL0501"),
      description: t("RAL0502"),
      link: "workday.com",
    },
    {
      logo: <img src={ZlinkLogo} alt={"ZlinkLogo"} height={56} width={56} />,
      name: t("RAL0503"),
      description: t("RAL0504"),
      link: "zlink.minervaiot.com",
    },
  ];

  useEffect(() => {
    const updatedData = data.map((item) => ({
      ...item,
    }));
    setApps(updatedData);
  }, [i18n.language, t]);

  useEffect(() => {
    if (appIdToDelete) {
      setOpenConfrimPrompt(true);
    } else {
      setOpenConfrimPrompt(false);
    }
  }, [appIdToDelete]);

  useEffect(() => {
    getIntegrations().then((response) => {
      if (response.data.code === "RCI0000") {
        setApps(response.data.data);
        // listUserIntegrations().then((res) => {
        //   let userIntegrations = undefined;
        //   if (res.status === 200 && res.data.data) {
        //     userIntegrations = res.data.data.integrations;
        //     setMyIntegrations(res.data.data.integrations);
        //   }

        //   if (response.data.data && response.data.data instanceof Array) {
        //     let applications = data;
        //     applications.forEach((a) => {
        //       a.active = false;
        //       a.enabled = false;
        //       let match = response.data.data.filter(
        //         (ap) => ap?.name === a.name
        //       );
        //       if (match && match instanceof Array && match.length > 0) {
        //         a.active = true;
        //         if (match[0].authorizeUrl) {
        //           a.authoraizationUrl = match[0].authorizeUrl;
        //         }
        //         if (
        //           userIntegrations &&
        //           userIntegrations instanceof Array &&
        //           userIntegrations.length > 0
        //         ) {
        //           userIntegrations.forEach((i) => {
        //             if (i.applicationId === match[0].id) {
        //               a.enabled = true;
        //               a.id = i.id;
        //               if (i.applicationUserId) {
        //                 a.link = i.applicationUserId;
        //               }
        //             }
        //           });
        //         }
        //       }
        //     });
        //     setApps(applications);
        //   }
        // });
        callUserIntegrations(response.data.data);
      }
    });
  }, []);

  const callUserIntegrations = (apps) => {
    listUserIntegrations().then((res) => {
      let userIntegrations = undefined;
      if (res.status === 200 && res.data.data) {
        userIntegrations = res.data.data.integrations;
        setMyIntegrations(res.data.data.integrations);
      }

      if (apps instanceof Array) {
        let applications = data;
        applications.forEach((a) => {
          a.active = false;
          a.enabled = false;
          let match = apps.filter(
            (ap) => ap?.name?.toLowerCase() === a.name?.toLowerCase()
          );
          if (match && match instanceof Array && match.length > 0) {
            a.active = true;
            if (match[0].authorizeUrl) {
              a.authoraizationUrl = match[0].authorizeUrl;
            }
            if (
              userIntegrations &&
              userIntegrations instanceof Array &&
              userIntegrations.length > 0
            ) {
              userIntegrations.forEach((i) => {
                if (i.applicationId === match[0].id) {
                  a.enabled = true;
                  a.id = i.id;
                  if (i.applicationUserId) {
                    a.link = i.applicationUserId;
                  }
                }
              });
            }
          }
        });
        console.log(applications);
        setApps(applications);
      }
    });
  };

  useEffect(() => {
    if (myIntegrations && myIntegrations.length > 0) {
      const biotimeCloudName = t("RAL0485");
      let biotimeIntegrationId = apps?.filter(
        (a) => a.name === biotimeCloudName
      );
      if (biotimeIntegrationId?.length > 0) {
        biotimeIntegrationId = biotimeIntegrationId[0].id;
      }
      if (biotimeIntegrationId) {
        let biotimeIntegrationResponse = myIntegrations.filter(
          (ui) => ui.applicationId === biotimeIntegrationId
        );
        if (biotimeIntegrationResponse.length > 0) {
          setBioTimeUser(biotimeIntegrationResponse[0]);
          setBiotimeToggle(true);
        }
      }

      let jiraIntegrationId = apps?.filter((a) => a.name === "Jira");
      if (jiraIntegrationId?.length > 0) {
        jiraIntegrationId = jiraIntegrationId[0].id;
      }
      if (jiraIntegrationId) {
        let jiraIntegrationIdResponse = myIntegrations.filter(
          (ui) => ui.applicationId === jiraIntegrationId
        );
        if (jiraIntegrationIdResponse.length > 0) {
          // setBioTimeUser(biotimeIntegrationResponse[0]);
          setJiraToggle(true);
        }
      }
    } else {
      setBioTimeUser(false);
      setBiotimeToggle(false);
    }
  }, [myIntegrations]);

  useEffect(() => {}, []);

  // useEffect(() => {
  //   if (biotimeUser && biotimeUser.id) {
  //     const format = "YYYY-MM-DD HH:mm:ss";
  //     let payload = {
  //       startTime: dayjs().startOf("day").format(format),
  //       endTime: dayjs().endOf("day").format(format),
  //       empCode: biotimeUser.userData?.emp_code,
  //     };
  //     listUserTransactions(biotimeUser.id, payload).then((res) => {
  //       if (res.status === 200) {
  //         setBioTimeUserTransactions(res.data.data?.data);
  //       }
  //     });
  //   }
  // }, [biotimeUser]);

  const handleDelete = () => {
    deleteIntegration(appIdToDelete).then((res) => {
      if (res.data.code === "RCI0000") {
        setAppIdtoDelete(undefined);

        setApps([]);
        setTimeout(() => {
          let applications = apps;
          applications.forEach((a) => {
            if (a.id === appIdToDelete) {
              a.id = "";
              a.enabled = false;
              a.link = "biotimecloud.info";
            }
          });
          setApps(applications);
        }, 500);
        toast.success(t("RAL0505"));
      } else {
        toast.success(t("RAL0506"));
      }
    });
  };

  const handleInitDataSync = (id) => {
    initDataSync(id).then((res) => {
      if (res.data.code === "RCI0000") {
        toast.success(t("RAL0507"));
      } else {
        toast.success(t("RAL0508"));
      }
    });
  };

  const getPopupTitle = (subscriptionDetails, t, isRestrictPopup = false) => {
    if (CommonUtil.getStatusCondition(subscriptionDetails)) {
      return isRestrictPopup ? t("RAL0902") : t("RAL0861");
    } else if (CommonUtil.isPlanCodeDefault(subscriptionDetails)) {
      return t("RAL0850");
    } else {
      return t("RAL0852");
    }
  };

  const getPopupContent = (subscriptionDetails, t, isRestrictPopup = false) => {
    if (CommonUtil.getStatusCondition(subscriptionDetails)) {
      return isRestrictPopup ? t("RAL0903") : t("RAL0862");
    } else if (CommonUtil.isPlanCodeDefault(subscriptionDetails)) {
      return t("RAL0849");
    } else {
      return t("RAL0851");
    }
  };

  const handleIntegrationToggle = (toggle, app) => {
    const biotimeCloudName = t("RAL0485");
    if (!toggle) {
      setAppIdtoDelete(app.id);
      return;
    }
    if (app.name === biotimeCloudName) {
      if (toggle) handleBiotimeToggle(toggle);
    } else if (app.authoraizationUrl) {
      window.location.replace(app.authoraizationUrl, "", "_self");
    }
  };

  useEffect(() => {
    const isActive = ["live", "non_renewing"].includes(
      subscriptionDetails?.status
    );
    const reportFeature = subscriptionDetails?.features?.find(
      (feature) => feature?.feature?.code === "INTEGRATION"
    );
    if (subscriptionDetails && subscriptionDetails?.status && !isActive) {
      if (!["OWNER"].includes(CommonUtil.getRoleCode())) {
        setRestrictPopupOpen(true);
      } else {
        setUpgradePopupOpen(true);
      }
    }
  }, [subscriptionDetails]);

  const handleBiotimeToggle = (toggle) => {
    const isActive = ["live", "non_renewing"].includes(
      subscriptionDetails?.status
    );

    const reportFeature = subscriptionDetails?.features?.find(
      (feature) => feature?.feature?.code === "INTEGRATION"
    );

    if ((toggle && !isActive) || !reportFeature) {
      if (!["OWNER"].includes(CommonUtil.getRoleCode())) {
        setRestrictPopupOpen(true);
        return;
      } else {
        setUpgradePopupOpen(true);
        return;
      }
    }
    if (toggle && !biotimeUser) {
      setBiotimeToggle(true);
      setOpenBiotimeForm(true);
    } else {
      setBiotimeToggle(false);
      setOpenBiotimeForm(false);
    }
  };

  const handleBiotimeFormClose = () => {
    setOpenBiotimeForm(false);

    listUserIntegrations().then((res) => {
      if (res.status === 200 && res.data.data) {
        const data = res.data.data.integrations;
        const biotimeCloudName = t("RAL0485");
  
        const updatedApps = apps.map(app => {
          if (app.name === biotimeCloudName) {
            return {
              ...app,
              id: data[0]?.id || "",
              enabled: !!data[0]?.id,
              link: data[0]?.applicationUserId || app.link
            };
          }
          return app;
        });
        setApps(updatedApps);
        setMyIntegrations(data);
      }
    });
  };

  return CommonUtil.getRoleCode() !== "CLIENT" ? (
    <>
      <ContentLayout title={t("RAL0452")} bg={"transparent"}>
        <div
          className={css`
            width: 100%;
          `}
        >
          <div
            className={css`
              width: 100%;
              height: 25vh;
              border-radius: 5px;
              background-image: url(${Banner});
              background-size: cover; /* Ensures the image covers the entire div */
              background-position: center; /* Centers the image within the div */
              background-repeat: no-repeat; /* Prevents the image from repeating */
              display: flex;
              align-items: center;
            `}
          >
            <Box px={8}>
              <Box pb={2}>
                <Typography
                  className={css`
                    font: normal normal normal 36px/42px GothamBold !important;
                    letter-spacing: 0px;
                    color: #ffffff !important;
                    opacity: 1;
                    @media (min-width: 1500px) {
                      font: normal normal normal 42px/46px GothamBold !important;
                    }
                  `}
                >
                  {t("RAL0509")}
                </Typography>
              </Box>
              <Typography
                className={css`
                  font: normal normal normal 16px/24px Gotham !important;
                  letter-spacing: 0px;
                  color: #ffffff !important;
                  opacity: 1;
                  @media (min-width: 1500px) {
                    font: normal normal normal 20px/34px Gotham !important;
                  }
                `}
              >
                {t("RAL0510")}
              </Typography>
            </Box>
          </div>
          <Box sx={{ padding: "30px 5px" }}>
            <Typography
              className={css`
                font: normal normal bold 20px/22px GothamBold !important;
                letter-spacing: 0px;
                color: var(--text-secondary-80) !important;
                opacity: 1;
              `}
            >
              {t("RAL0484")}
            </Typography>
          </Box>
          <Box
            flexWrap={"wrap"}
            className={css`
              display: grid;
              grid-template-columns: repeat(auto-fit, minmax(362px, 1fr));
              gap: 30px;
              @media (max-width: 1600px) {
                grid-template-columns: repeat(auto-fit, minmax(280px, 1fr));
                gap: 20px;
              }
            `}
          >
            {apps?.map((i) => {
              return (
                <Box
                  className={css`
                    background: var(--background-color-3) 0% 0% no-repeat
                      padding-box;
                    border-radius: 5px;
                    opacity: 1;
                    padding: 24px;
                    // width: ${isXlScreen ? "24.28%" : "23.9%"};
                    // width: calc(25% - 23px);
                  `}
                >
                  <Box item display={"flex"} width={"100%"}>
                    <Box flexGrow={1} height={"56px"}>
                      {i.logo}
                    </Box>
                    <Box>
                      {i?.name === t("RAL0485") ? (
                        <CustomSwitch
                          className="CustomSwitch"
                          id="btn-custom-biotime"
                          checked={i.enabled}
                          value={i.enabled}
                          onChange={(e) => {
                            handleIntegrationToggle(e.target.checked, i);
                          }}
                        />
                      ) : (
                        <CustomSwitch
                          sx={{
                            cursor: "not-allowed !important",
                            "& .MuiSwitch-thumb": {
                              backgroundColor:
                                "var(--background-color-36) !important",
                            },
                            "& .MuiSwitch-track": {
                              border:
                                "1px solid var(--border-color-6) !important",
                            },
                          }}
                          disabled
                        />
                      )}
                    </Box>
                  </Box>
                  <Box py={2}>
                    <Typography
                      className={css`
                        font: normal normal normal 16px/26px GothamMedium !important;
                        letter-spacing: 0px;
                        color: var(--text-secondary-80) !important;
                        opacity: 1;
                      `}
                    >
                      {i.name}
                    </Typography>
                  </Box>
                  <Box pb={1} minHeight={"100px"}>
                    <Typography
                      className={css`
                        font: normal normal normal 14px/24px Gotham !important;
                        letter-spacing: 0px;
                        color: var(--text-secondary-50) !important;
                        opacity: 1;
                      `}
                    >
                      {i.description}
                    </Typography>
                  </Box>
                  <Box display={"flex"}>
                    <Typography
                      className={css`
                        font: normal normal normal 14px/26px Gotham !important;
                        letter-spacing: 0px;
                        color: var(--text-light-color-blue) !important;
                        opacity: 1;
                        flex-grow: 1;
                      `}
                    >
                      {i.link}
                    </Typography>
                    {i.enabled && i.name.includes(t("RAL0485")) && (
                      <Box>
                        {mode == "light" ? (
                          <RefreshIcon
                            className="icon"
                            onClick={() => handleInitDataSync(i?.id)}
                          />
                        ) : (
                          <RefreshIconDark
                            onClick={() => handleInitDataSync(i?.id)}
                          />
                        )}
                      </Box>
                    )}
                  </Box>
                </Box>
              );
            })}
          </Box>
        </div>
        {/* <Box>
          {headcard}
          <Box py={3}>
            <Typography
              className={css`
                font: normal normal bold 20px/22px GothamBold !important;
                letter-spacing: 0px;
                color: #242424;
                opacity: 1;
              `}
            >
              Applications for the integration
            </Typography>
          </Box>
          <Box display={"flex"} columnGap={3}>
            <Box item>{IntegrationContents()}</Box>
            <Box item>{biotTimeIntegrationCard}</Box>
            <Box
              item
              className={css`
                background: #ffffff 0% 0% no-repeat padding-box;
                border-radius: 5px;
                opacity: 1;
              `}
            ></Box>
          </Box>
          <BiotimeLogin
            open={openBiotimeForm}
            onClose={() => handleBiotimeFormClose()}
          />
        </Box> */}
        <BiotimeLogin
          open={openBiotimeForm}
          onClose={() => handleBiotimeFormClose()}
        />
      </ContentLayout>
      <CustomDialogBox
        id="btn-remove-integration"
        Header={t("RAL0641")}
        acceptText={t("RAL0165")}
        cancelText={t("RAL0164")}
        fullWidth={true}
        onClick={() => setAppIdtoDelete(undefined)}
        onSubmit={() => handleDelete()}
        open={openConfirmPrompt}
        type="remove"
      >
        <Grid
          container
          justifyContent="center"
          direction="column"
          alignItems="center"
          style={{ padding: "20px" }}
        >
          <Grid>
            <Grid
              style={{
                wordWrap: "break-word",
                opacity: 1,
                textAlign: "center",
                display: "flex",
                flexDirection: "row",
                fontSize: "17px",
              }}
            >
              <Typography
                className="dialogInfo"
                sx={{
                  color:
                    mode === "light"
                      ? "#242424cc!important"
                      : "#f8f8f880!important",
                }}
              >
                {t("RAL0512")}
              </Typography>
            </Grid>
          </Grid>
        </Grid>
      </CustomDialogBox>

      {["OWNER"].includes(CommonUtil.getRoleCode()) && (
        <UpgradePopup
          open={upgradePopupOpen}
          onClose={() => setUpgradePopupOpen(false)}
          onConfirm={() => {
            if (CommonUtil.getRoleCode() === "OWNER") {
              navigate("/subscription-manage");
            } else {
              navigate("/page-not-found");
            }
          }}
          title={getPopupTitle(subscriptionDetails, t)}
          content={getPopupContent(subscriptionDetails, t)}
          cancelText={t("RAL0177")}
          confirmText={t("RAL0848")}
        />
      )}

      {!["OWNER"].includes(CommonUtil.getRoleCode()) && (
        <RestrictPermissionPopup
          open={restrictPopupOpen}
          onClose={() => setRestrictPopupOpen(false)}
          title={getPopupTitle(subscriptionDetails, t, true)}
          content={getPopupContent(subscriptionDetails, t, true)}
          cancelText={t("RAL0177")}
        />
      )}
    </>
  ) : (
    <></>
  );
}
